import script from "./QuizMaker.vue?vue&type=script&setup=true&lang=js"
export * from "./QuizMaker.vue?vue&type=script&setup=true&lang=js"

import "./QuizMaker.vue?vue&type=style&index=0&id=d6398168&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-d6398168"]])

export default __exports__